import { getTaskRequest, useTask } from '~/contexts/TaskContext'

export interface RepoContext {
  connType: string
  orgName?: string
  repoName?: string
  branchName?: string
  commitId?: string
  s3TarFilePath?: string
}

/**
 * Returns a unified array of repository contexts from task metadata.
 * Handles both single and multi-repo cases in a consistent format.
 */
export function useRepoContexts(): RepoContext[] {
  const { task } = useTask()
  const request = getTaskRequest(task)

  // Check for multi-repo context first
  const multiRepoContexts = request?.metadata?.multiRepoCodeContext
  if (multiRepoContexts && Array.isArray(multiRepoContexts) && multiRepoContexts.length > 0) {
    return multiRepoContexts.map(ctx => ({
      connType: ctx.connType || '',
      orgName: ctx.orgName || '',
      repoName: ctx.repoName || '',
      branchName: ctx.branchName || '',
      commitId: ctx.commitId || '',
      s3TarFilePath: ctx.s3TarFilePath || ''
    }))
  }

  // Fall back to single repo context
  const singleContext = request?.metadata?.codeContext
  if (singleContext) {
    return [
      {
        connType: singleContext.connType || '',
        orgName: singleContext.orgName || '',
        repoName: singleContext.repoName || '',
        branchName: singleContext.branchName || '',
        commitId: singleContext.commitId || '',
        s3TarFilePath: singleContext.s3TarFilePath || ''
      }
    ]
  }

  return []
}
